export class VimeoConsent {

    currentVimeoVideo = null;
    options = {};
    locales = {};

    constructor(options) {
        this.options = options;
        this.loadLocales();
        this.activateVimeoConsent();
    }

    activateVimeoConsent() {

        var vimeoVideos = document.querySelectorAll('.vimeo-loading');

        Array.prototype.forEach.call(vimeoVideos, (el, i) => {

            el.addEventListener('click', (e) => {

                e.preventDefault();
                this.getUserConsent(e.currentTarget);

            })
        });

    }

    getUserConsent(vimeoVideo) {

        // store video DOM object so we can reference it later
        this.currentVimeoVideo = vimeoVideo;
        this.injectConsentMarkup(vimeoVideo);

    }

    injectConsentMarkup(vimeoVideo) {

        const consentMarkup = `
            <div class="vimeo-consent-body">
                <p>${this.locales.infoText}</p>
                <div class="btn-group">
                    <button type="button" class="btn btn-secondary" id="reject-vimeo-video">${this.locales.reject}</button>
                    <button type="button" class="btn btn-primary" id="confirm-vimeo-video">${this.locales.confirm}</button>
                </div>
            </div>`;

        const consent = document.createElement('div');
        consent.classList.add('vimeo-consent');
        consent.innerHTML = consentMarkup;

        vimeoVideo.parentElement.appendChild(consent);
        document.querySelector('#confirm-vimeo-video').addEventListener('click', () => this.loadVimeoVideo());
        document.querySelector('#reject-vimeo-video').addEventListener('click', () => this.rejectVimeoVideo());

    }

    loadVimeoVideo() {
        const vimeoId = this.getVimeoVideoId();
        this.currentVimeoVideo.parentElement.innerHTML = this.getVimeoEmbedCode(vimeoId);
    }

    rejectVimeoVideo() {
        this.currentVimeoVideo.parentElement.querySelector('.vimeo-consent').remove();
    }

    getVimeoEmbedCode(vimeoId) {
        return '<div class="video"><iframe width="100%" height="315" src="https://player.vimeo.com/video/' + vimeoId + '" frameborder="0" allow="autoplay; picture-in-picture allowfullscreen"></iframe></div>';
    }

    getVimeoVideoId() {
        var urlParts = this.currentVimeoVideo.href;
        var match = /vimeo.*\/(\d+)/i.exec( urlParts );
        if ( match ) {
            return match[1];
        }
    }

    loadLocales() {
        const currentLanguage = this.getLanguage();
        const fallbackLocale = this.options.localeDefault || 'en';
        if (this.options.locales[currentLanguage]) {
            this.locales = this.options.locales[currentLanguage];
        } else {
            this.locales = this.options.locales[fallbackLocale];
        }
    }

    getLanguage() {
        return document.documentElement.lang.split('-')[0];
    }

}


export default VimeoConsent;
